import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import {
  Table,
  Row,
  Col,
  ConfigProvider,
  Button,
  InputNumber,
  Input,
  Divider,
} from "antd"
import { getListEngineer, getListQuarterTariff } from "store/actions"
import { serializeQuery } from "helpers/service_helper"
import { ListQuarterTariff } from "../common/ListQuarterTariff"
import { EngQuotaBurnColumnsAnt } from "./EngQuotaBurnColumnsAnt"
import { ListEngineer } from "../common/ListEngineer"
import "./engWork.scss"
import {
  engQuotaBurnApproved,
  engQuotaBurnUpdate,
  getEngQuotaBurnList,
  getEngQuotaBurnListSuccess,
  resetEngQuota,
} from "store/quotas/actions"
const ListEngQuotaBurn = props => {
  const {
    lstEngQuotaBurn,
    loading,
    onGetEngQuotaBurn,
    onGetEngQuotaBurnSuccess,
    onEngQuotaBurnUpdate,
  } = props

  const [quarterId, setQuarterId] = useState(null)
  const [engineerId, setEngineerId] = useState(null)
  const [des, setDes] = useState("")
  const [amountBurning, setAmountBurning] = useState(0)

  const onChange = (pagination, filters, sorter, extra) => {}

  const insert = () => {
    onEngQuotaBurnUpdate({
      id: null,
      qtId: quarterId,
      engId: engineerId,
      des: des,
      amountBurning: amountBurning,
    })
  }

  useEffect(async () => {
    if (quarterId) {
      handleSearchEngWork()
    } else {
      onGetEngQuotaBurnSuccess()
    }
  }, [quarterId, engineerId])
  // Fetch data or set initial values if needed
  const handleSearchEngWork = async val => {
    let searchQuery = {
      qtId: quarterId ? quarterId : "",
      engId: engineerId ? engineerId : "",
      burnTypeEnum:1
    }

    const params = serializeQuery(searchQuery)
    onGetEngQuotaBurn(params)
  }

  return (
    <>
      <Row gutter={[16, 6,16,6]}>
        <Col span={12}>
          <ListQuarterTariff selectQuarter={setQuarterId} props={props} />
        </Col>
        <Col span={12}>
          <ListEngineer selectEngineer={setEngineerId} props={props} />
        </Col>
        <Col span={12}>
          <InputNumber
            style={{ width: "100%" }}
            formatter={value =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            defaultValue={0}
            width={100}
            min={0}
            onChange={e=>setAmountBurning(e)}
          />
        </Col>
        <Col span={12}>
          <Input.TextArea
            style={{ width: "100%" }}
            rows={2}
            width={100}
            onChange={e=>setDes(e.target.value)}

          />
        </Col>
        <Col span={24}>
          <Button
            disabled={loading || !quarterId || !quarterId}
            onClick={() => insert()}
            type="primary"
          >
            ذخیره
          </Button>
        </Col>
      </Row>
      <Divider />
      <div style={{ minHeight: "600px" }}>
        <Table
          loading={loading}
          size="small"
          pagination={{ pageSize: 10 }}
          sticky
          scroll={{ y: 600 }}
          columns={EngQuotaBurnColumnsAnt({
            props,
            period: props.lstQuarterTariff.find(x => x.id === quarterId)
              ?.period,
          })}
          rowClassName={(_r, i) => (i % 2 ? "odd" : "even")}
          rowKey={record => record.id}
          dataSource={lstEngQuotaBurn}
          onChange={onChange}
          style={{ zIndex: 99999 }}
        />
      </div>
    </>
  )
}

const mapStateToProps = ({ Quotas, QuarterTariffs, Engineers }) => ({
  lstEngQuotaBurn: Quotas.lstEngQuotaBurn,
  lstQuarterTariff: QuarterTariffs.lstQuarterTariff,
  lstEngineer: Engineers.lstEngineer,
  error: Quotas.error,
  success: Quotas.success,
  loading: Quotas.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetEngQuotaBurn: query => dispatch(getEngQuotaBurnList(query)),
  onGetEngQuotaBurnSuccess: () => dispatch(getEngQuotaBurnListSuccess([])),
  onGetListQuarterTariff: () => dispatch(getListQuarterTariff()),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onResetEngQuota: () => dispatch(resetEngQuota()),
  onEngQuotaBurnApproved: data => dispatch(engQuotaBurnApproved(data)),
  onEngQuotaBurnUpdate: data => dispatch(engQuotaBurnUpdate(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListEngQuotaBurn)
